import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { galleryApi } from '../api/client'
import BeadPlacingMode from '../components/BeadPlacingMode'
import { findBrandOption, findBrandByName } from '../utils/beadData'

const LOCAL_KEY = 'pindou_bead_mode_pattern'

// Home 的工作台图纸（未保存到图集）通过 sessionStorage 传入
export function setLocalBeadModePattern(pattern, brandId) {
  try {
    sessionStorage.setItem(LOCAL_KEY, JSON.stringify({ pattern, brandId }))
  } catch (err) {
    console.warn('[bead-mode] 图纸过大无法暂存', err)
  }
}

// 拼豆模式独立页面：
//   /bead-mode/local        工作台当前图纸（sessionStorage）
//   /bead-mode/:id          图集图纸
//   /bead-mode/share/:code  分享码图纸
export default function BeadModePage() {
  const { id, code } = useParams()
  const navigate = useNavigate()
  const [state, setState] = useState({ loading: true, pattern: null, brand: null, error: '' })

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      try {
        if (id === 'local') {
          const raw = sessionStorage.getItem(LOCAL_KEY)
          if (!raw) throw new Error('没有找到工作台图纸，请先生成图纸')
          const { pattern, brandId } = JSON.parse(raw)
          if (!cancelled) setState({ loading: false, pattern, brand: findBrandOption(brandId), error: '' })
          return
        }
        const res = code ? await galleryApi.getByShareCode(code) : await galleryApi.get(id)
        const item = res.data
        if (!item?.pattern || !item.canViewPattern) throw new Error('图纸已被锁定或不存在')
        if (!cancelled) setState({ loading: false, pattern: item.pattern, brand: findBrandByName(item.brand), error: '' })
      } catch (err) {
        if (!cancelled) {
          setState({
            loading: false,
            pattern: null,
            brand: null,
            error: err.response?.data?.error || err.message || '加载失败',
          })
        }
      }
    }
    load()
    return () => { cancelled = true }
  }, [id, code])

  if (state.loading) {
    return (
      <div className="flex h-[60vh] items-center justify-center text-cocoa-light">加载图纸中…</div>
    )
  }

  if (state.error || !state.pattern || !state.brand) {
    return (
      <div className="flex h-[60vh] flex-col items-center justify-center gap-4 text-center">
        <p className="text-4xl">🧩</p>
        <p className="text-cocoa">{state.error || '图纸不存在'}</p>
        <button onClick={() => navigate(-1)} className="btn-soft">返回</button>
      </div>
    )
  }

  return (
    <BeadPlacingMode
      open
      pattern={state.pattern}
      brand={state.brand}
      onClose={() => navigate(-1)}
    />
  )
}
